// Fase 2 (W11): My assistants, Approve action, passkeys, usage panel, trash and level by role (en).
export const assistentesEn = {
  // Lote 19/10: MCP OAuth consent screen.
  oauth: {
    kicker: 'OAuth connection',
    titulo: 'Authorize access to MalgoOS',
    pedido: '{{cliente}} wants to access MalgoOS on your behalf',
    cliente: 'Client',
    volta: 'Returns to',
    registrado: 'Registered on',
    workspace: 'Workspace',
    empresa: 'Company',
    todas: 'All the companies you see',
    escopos: 'What the client can do',
    escoposAjuda: 'Never more than you can. Sensitive writes wait for your confirmation, as with assistants, and roles, keys and settings stay with you only.',
    assistente: 'The connection shows up in My account > My assistants, where you see what it did and can revoke it.',
    desligado: 'OAuth connections are turned off in this workspace. Ask an administrator to allow them in Integrations > MCP.',
    aprovar: 'Authorize',
    recusar: 'Deny',
    autorizado: 'Access authorized',
    recusado: 'Access denied',
    voltando: 'Going back to {{cliente}}...',
    erroTitulo: 'Could not authorize',
    erros: {
      cliente_invalido: 'Unknown client. Start again from the app that asked for access.',
      redirect_invalido: 'The return address is not the one the client registered. For safety, access was not granted.',
      pedido_invalido: 'Invalid authorization request. Start again from the app that asked for access.',
    },
  },
  aba: 'My assistants',
  titulo: 'My assistants',
  texto: 'Your AI assistant works on your behalf, with at most your permissions. It does reversible actions directly; it prepares sensitive ones and waits for your confirmation; it never touches roles, keys or settings.',
  novo: 'New assistant',
  vazioTitulo: 'You have no assistant yet',
  vazioTexto: 'Create an assistant, choose the modules and the limits and use its key in your agent (MCP).',
  escopoTodos: 'All modules you can access',
  semChave: 'No active key',
  nunca: 'Never',
  semLimiteCurto: 'No cap',
  qualquerHora: 'Any time',
  verAtividade: 'What it did',
  novaChave: 'New key',
  reativar: 'Reactivate',
  revogar: 'Revoke',
  revogado: 'Assistant revoked',
  reativado: 'Assistant reactivated',
  suspenso: 'Assistant suspended. Reactivate it when you want it to work again.',
  suspensoAnomalia: 'Suspended by the unusual behavior alert (too many deletions in a short time). Check what it did before reactivating.',
  revogarTitulo: 'Revoke {{nome}}?',
  revogarTexto: 'The key stops working right away and the actions waiting for your confirmation expire. This cannot be undone.',
  novaChaveTitulo: 'Generate a new key?',
  novaChaveTexto: 'The current key stops working right away. Replace the key in your agent next.',
  estados: { ativo: 'Active', suspenso: 'Suspended', revogado: 'Revoked' },
  estadosAprovacao: { pendente: 'Waiting for you', aprovada: 'Approved', recusada: 'Declined', expirada: 'Expired', falhou: 'Not completed' },
  campos: {
    chave: 'Key',
    ultimoUso: 'Last used',
    hoje: 'Actions today',
    deLimite: '{{n}} of {{limite}}',
    pendentes: 'Waiting for you',
    valorMaximo: 'Cap per operation',
    horario: 'Hours',
  },
  niveis: { n1: 'does it directly', n2: 'asks for your confirmation', n3: 'never does it' },
  dias: { 0: 'Sun', 1: 'Mon', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sat' },
  chave: {
    titulo: 'Assistant key',
    copiar: 'Copy key',
    guardei: 'I saved it',
    texto: 'This is the only time the key is shown. Save it in your agent now; if you lose it, generate a new one.',
    como: 'In the agent, use the MCP server at {{url}} with the header Authorization: Bearer followed by the key.',
  },
  form: {
    editar: 'Edit {{nome}}',
    criar: 'Create assistant',
    nome: 'Name',
    nomeAjuda: 'What you call your assistant (for example, Oliv).',
    escopo: 'What it can access',
    escopoTexto: 'It never goes beyond your permissions. Choose only what it needs.',
    todos: 'All modules I can access',
    semAcesso: 'No access',
    leitura: 'Read only',
    escrita: 'Read and write',
    escolhaModulo: 'Choose at least one module',
    confirmacao: 'Confirmation',
    confirmarTudo: 'Also ask for my confirmation on reversible actions',
    prazo: 'Time for me to confirm',
    horas_one: '{{count}} hour',
    horas_other: '{{count}} hours',
    niveisTitulo: 'What it does alone and what needs confirmation',
    niveisTexto: 'By your role. Deleting, money, personal data and external sending ask for your confirmation; what is reserved only you do, directly on screen.',
    nenhumaAcao: 'None of your actions at this level.',
    limites: 'Limits',
    acoesPorDia: 'Actions per day',
    semLimite: 'Blank means no cap.',
    valorMaximo: 'Maximum amount per financial operation',
    valorInvalido: 'Invalid amount',
    horarioInicio: 'Can work from',
    horarioFim: 'Until',
    horarioIncompleto: 'Fill in both the start and the end, or neither',
    dias: 'Allowed days',
    diasAjuda: 'None checked means every day.',
    anomaliaExclusoes: 'Alert: deletions',
    anomaliaJanela: 'Within how many minutes',
    anomaliaAjuda: 'Past this number of deletions within the window, the assistant is suspended and you get a notice.',
  },
  atividade: { vazio: 'It has not done anything yet.', aprovada: 'Approved by you' },
  pendentes: {
    titulo_one: '{{count}} action waiting for your confirmation',
    titulo_other: '{{count}} actions waiting for your confirmation',
    linha: '{{assistente}}: {{acao}} in {{modulo}}',
    expira: 'Expires at {{data}}',
    revisar: 'Review',
  },
  uso: {
    titulo: 'Assistant usage',
    texto: 'From {{de}} to {{ate}}. Counts what the assistants did on your behalf and what you did directly on screen.',
    pessoa: 'Person',
    eu: '{{nome}} (you)',
    vazioTitulo: 'No usage in the period',
    vazioTexto: 'When the assistant works, the numbers show up here.',
    acionamentos: 'Calls',
    feitas: 'Actions it did',
    preparadas: 'Actions prepared',
    pendentesAgora_one: '{{count}} waiting now',
    pendentesAgora_other: '{{count}} waiting now',
    tempoMedio: 'Time to confirmation',
    aprovadas: 'Approved',
    falharam_one: '{{count}} not completed',
    falharam_other: '{{count}} not completed',
    recusadas: 'Declined',
    expiradas: 'Expired',
    viaAssistente: 'Through the assistant',
    viaDetalhe: '{{via}} through the assistant, {{direto}} directly on screen',
    semDado: 'No data',
    modulos: 'Modules most used by the assistant',
    semModulos: 'No changes by the assistant in the period.',
    segundos: '{{n}} s',
    minutos: '{{n}} min',
    horas: '{{n}} h',
  },
  lixeira: {
    titulo: 'Undo what the assistant deleted',
    texto: 'Deletions by your assistants in the last 30 days. Undo brings the record back as it was.',
    vazioTitulo: 'Nothing to undo',
    vazioTexto: 'What the assistant deletes shows up here for 30 days.',
    ate: 'Can be undone until {{data}}',
    desfazer: 'Undo',
    restaurado: 'Record restored',
  },
  passkeys: {
    titulo: 'Passkeys',
    texto: 'A passkey confirms the sensitive actions of your assistant with the biometrics of your device (Face ID, Touch ID or fingerprint). MalgoOS does not store your biometrics.',
    nova: 'New passkey',
    novaTexto: 'Name the device and confirm with your password. Then the device asks for your biometrics.',
    criar: 'Create passkey',
    nome: 'Device name',
    nomeAjuda: 'For example, Phone or Laptop.',
    cadastrada: 'Passkey created',
    cancelada: 'The passkey was not confirmed on the device. Try again.',
    semSuporte: 'This browser does not support passkeys. Use the authenticator app code to confirm.',
    vazioTitulo: 'No passkey',
    vazioTexto: 'Create a passkey to approve with one tap what your assistant prepares.',
    criadaEm: 'Created on {{data}}',
    usadaEm: 'used on {{data}}',
    remover: 'Remove',
    removerNome: 'Remove the passkey {{nome}}',
    removerTitulo: 'Remove the passkey {{nome}}?',
    removerTexto: 'This device will no longer confirm the assistant actions.',
    removida: 'Passkey removed',
  },
  aprovar: {
    kicker: 'Assistant',
    titulo: 'Approve action',
    pedido: '{{assistente}} asks for your confirmation',
    modulo: 'Module',
    acao: 'Action',
    valor: 'Amount',
    registro: 'Record',
    pedidoEm: 'Requested at',
    expiraEm: 'Expires at',
    decididaEm: 'Decided at',
    rota: 'Route',
    dados: 'What will be done',
    semDados: 'No data besides the record.',
    feita: 'Action approved and done',
    feitaTexto: 'It was done by {{assistente}} on your behalf and is in the audit log.',
    falhou: 'Approved, but not completed',
    falhouTexto: 'Nothing was saved.',
    recusada: 'Action declined',
    recusadaTexto: 'Nothing was done.',
    expirada: 'The time ran out',
    expiradaTexto: 'The action was not done. Ask the assistant again if you still need it.',
    semPasskey: 'No passkey registered. Create one in My account, Security, or use the app code.',
    semConfirmacao: 'To approve, create a passkey or turn on two step verification.',
    irSeguranca: 'Go to Security',
    recusar: 'Decline',
    usarCodigo: 'Use app code',
    aprovarCodigo: 'Approve with the code',
    aprovarPasskey: 'Approve with passkey',
    recusarTitulo: 'Decline the action?',
    recusarTexto: '{{assistente}} will not do this action.',
    naoEncontrada: 'Approval not found',
    naoEncontradaTexto: 'It does not exist or belongs to someone else.',
    irAssistentes: 'Go to My assistants',
  },
  papel: {
    titulo: 'Risk level for assistants',
    texto: 'Applies to the assistants of people with this role. Each person can make their own assistant stricter, never looser.',
    travado: 'Reserved to the person (N3)',
    fabrica: 'Default ({{nivel}})',
  },
};
